import { useOutletContext } from 'react-router-dom';
import { ActivityInfo, Chatroom } from '../../models';

export function useActivityData() {
  return useOutletContext<{
    room: Chatroom | undefined;
    activityInfo: ActivityInfo | undefined;
  }>();
}
